import { PageWrapper } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetPayoutQuery } from 'services/payouts';

import LoadingIndicator from 'components/loadingIndicator';

import RoutePath from 'router/path';

import { getRequestSorting, useTableSorting } from 'utils/tables/sorting';

import { useRedirectOnAccountSwitch } from '../../utils/useRedirectOnAccountSwitch';
import { LABELS } from './keys';
import { PayoutDetails } from './payoutDetails';
import { KEYS as TRANSACTIONS_KEYS } from './sections/transactions/keys';

export const PayoutViewContainer = () => {
  const { t } = useTranslation();
  useRedirectOnAccountSwitch(RoutePath.Pwc.Orders.Root);

  const { uuid, accountUuid } = useParams();

  const { sorting, onSort } = useTableSorting({
    defaultSorting: {
      direction: TRANSACTIONS_KEYS.DEFAULT_TABLE_SORTING.DIRECTION,
      field: TRANSACTIONS_KEYS.DEFAULT_TABLE_SORTING.FIELD,
    },
  });

  const { data: payout, isLoading } = useGetPayoutQuery(
    { accountUuid: accountUuid!, payoutUuid: uuid!, sort: getRequestSorting(sorting) },
    {
      skip: !uuid || !accountUuid,
    },
  );

  const breadcrumbs = LABELS.BREADCRUMBS.map((item) => t(item));

  if (!uuid || !accountUuid || isLoading) {
    return (
      <PageWrapper pageTitle={t(LABELS.PAGE_TITLE)} breadcrumbs={breadcrumbs}>
        <LoadingIndicator padded />
      </PageWrapper>
    );
  }

  if (!payout?.data) {
    return null;
  }

  return (
    <PageWrapper breadcrumbs={breadcrumbs} pageTitle={t(LABELS.PAGE_TITLE)}>
      <PayoutDetails payoutData={payout?.data} isLoading={isLoading} onSort={onSort} sorting={sorting} />
    </PageWrapper>
  );
};
